import http from "../http";
import { GetUsersRequestTypes } from "src/redux/actions/users/types";

export const getUsers = (values: GetUsersRequestTypes) => {
  return http("api/Users", {
    params: values,
    method: "GET"
  });
};
